import { fetchWithToken } from "../utils/fetchWithToken";

/**
 * Packs d'une box legacy (toutes les box sauf Serenity), en LECTURE SEULE : ils se modifient
 * physiquement sur la machine. DATA `GET /license/{uuid}/legacy-packs` les demande à
 * VM_DEVICE_Legacy (dernier masque annoncé par la box) et les décode ; rien n'est stocké en base.
 */
export const LEGACY_PACK_CODES = [
  "energie_electrique",
  "energie_gaz",
  "besoin_auto",
  "pesage_silos",
  "dialogue_reseau",
  "analyse_donnees",
  "pesage_animaux",
] as const;

export type LegacyPackCode = (typeof LEGACY_PACK_CODES)[number];

/** `known` à faux : la box ne s'est pas annoncée depuis le dernier redémarrage du serveur. */
export type LegacyPacksView = {
  known: boolean;
  packs: LegacyPackCode[];
  temporary: LegacyPackCode[];
  received_at?: string;
};

const LEGACY_DEVICE_TYPES = ["avibox", "avitouch", "vigebox", "labelbox"];

/** Vrai pour les produits qui ont des packs (tous sauf Serenity). */
export const isLegacyDeviceType = (type?: string): boolean =>
  !!type && LEGACY_DEVICE_TYPES.includes(type);

/** Codes connus, dans l'ordre des bits (les codes inconnus du front sont écartés). */
const sortPacks = (codes: string[] | null | undefined): LegacyPackCode[] =>
  LEGACY_PACK_CODES.filter((code) => (codes ?? []).includes(code));

export const fetchLegacyPacks = async (
  uuid: string
): Promise<{ view: LegacyPacksView | null; error: string | null }> => {
  try {
    const response = await fetchWithToken(
      `${process.env.REACT_APP_URL_SERVER_DATA}/license/${encodeURIComponent(
        uuid
      )}/legacy-packs`,
      { method: "GET", headers: { "Content-type": "application/json" } }
    );
    if (response.status !== 200) {
      return { view: null, error: `HTTP ${response.status}` };
    }
    const data: Partial<LegacyPacksView> | null = await response.json();
    return {
      view: {
        known: !!data?.known,
        packs: sortPacks(data?.packs),
        temporary: sortPacks(data?.temporary),
        received_at: data?.received_at,
      },
      error: null,
    };
  } catch (err) {
    console.error("Erreur:", err);
    return { view: null, error: "network" };
  }
};
